module.exports = __webpack_public_path__ + "img/arrow-back.eafeca54.svg";